import request from '@/utils/request'

// 查询影院列表
export function listCinema(query) {
  return request({
    url: '/system/ep2Cinema/list',
    method: 'get',
    params: query
  })
}
